import { render, staticRenderFns } from "./PropertyType.vue?vue&type=template&id=30723473&scoped=true&"
import script from "./PropertyType.vue?vue&type=script&lang=ts&"
export * from "./PropertyType.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyType.vue?vue&type=style&index=0&id=30723473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30723473",
  null
  
)

export default component.exports